<div class="ranking-modal" [ngClass]="{ xSmallScreen: xSmallScreen }">
  <div class="modal-header">
    <h2 translate>watch.content.ranking.title</h2>
  </div>

  <div class="content-header">
    <div class="filter-container">
      <div class="filter-scroll">
        <app-ranking-filter
          [isIcon]="'new-filter'"
          (isActive)="activeFilter($event)"
          [active]="filterOn && filterId === null"
          [dotActive]="
            (selectedGender && selectedGender !== 'all') ||
            selectedAge ||
            selectedEquipment ||
            selectedMachineType ||
            selectedManufacturer
          " />

        <app-ranking-filter
          [withArrow]="true"
          (isActive)="activeFilter($event)"
          [active]="filterId === 'gender'"
          title="gender"
          [dotActive]="selectedGender && selectedGender !== 'all'" />

        <app-ranking-filter
          [withArrow]="true"
          (isActive)="activeFilter($event)"
          [active]="filterId === 'age'"
          title="age"
          [dotActive]="selectedAge" />

        <app-ranking-filter
          [withArrow]="true"
          (isActive)="activeFilter($event)"
          [active]="filterId === 'equipment'"
          title="equipment"
          [dotActive]="
            selectedEquipment || selectedMachineType || selectedManufacturer
          " />
      </div>

      @if (filterOn) {
        <div class="filter-content">
          <div #content class="content">
            <app-gender-filter-block [genderSelected]="selectedGender" />
            <app-age-filter-block [ageSelected]="selectedAge" />
            <app-equipment-filter-block
              [selectedEquipment]="selectedEquipment"
              [selectedManufacturer]="selectedManufacturer"
              [selectedMachineType]="selectedMachineType"
              [brandsList$]="brandsList$"
              [sportMachine]="machineType"
              (inputChanged$)="setSelectedValues($event)"
              (brandSelected$)="getBrandsList($event)" />
          </div>
          <div class="footer">
            <button class="btn-blue" (click)="resetFilter(filterId)">
              {{ 'watch.ranking_modal.button.delete' | translate }}
            </button>
            <button class="btn-primary" (click)="setRankingParams(filterId)">
              {{ 'watch.ranking_modal.button.filter' | translate }}
            </button>
          </div>
        </div>
      }
    </div>
    @if (userLogged) {
      <app-user-position [userRank]="userRanked" [userLogged]="userLogged" />
    }
  </div>

  <div class="content">
    <div class="divider"></div>
    <!-- RANKING -->
    <div
      class="ranking"
      infiniteScroll
      [infiniteScrollDistance]="1.1"
      [infiniteScrollThrottle]="70"
      [infiniteScrollDisabled]="rankingLoading$ | async"
      [fromRoot]="true"
      [infiniteScrollContainer]="scrollContainerSelector"
      (scrolled)="onScrollBottom()">
      <!-- RANKING ITEM -->
      @for (rankingItem of ranking$ | async; track $index) {
        <div class="ranking-item">
          <app-position-item [rank]="rankingItem.rank" />
          <div class="user-infos">
            <div class="avatar">
              @if (rankingItem.rank <= 3) {
                <span
                  [ngClass]="{
                    gold: rankingItem.rank === 1,
                    silver: rankingItem.rank === 2,
                    bronze: rankingItem.rank === 3,
                  }"
                  class="icon icon-crown"></span>
              }
              <img
                class="user-avatar"
                [src]="rankingItem.user?.avatar_url"
                [alt]="'the ' + rankingItem.user?.username + 'avatar.'"
                (click)="navToUserProfil(rankingItem.user?.id)" />
            </div>
            <div class="col-cont">
              <p
                class="user-name"
                (click)="navToUserProfil(rankingItem.user?.id)">
                {{ rankingItem.user?.username }}
              </p>
              @if (xSmallScreen) {
                <p
                  class="chrono"
                  (click)="navToActivity(rankingItem.activity_id)">
                  {{ rankingItem.activity_time | chrono }}
                </p>
              }
            </div>
          </div>
          @if (!xSmallScreen) {
            <p class="chrono" (click)="navToActivity(rankingItem.activity_id)">
              {{ rankingItem.activity_time | chrono }}
            </p>
          }
          <div class="row-cont">
            <div class="sex">
              <span
                class="icon"
                [ngClass]="
                  rankingItem.user?.gender === 'F'
                    ? 'icon-new-woman'
                    : rankingItem.user?.gender === 'M'
                      ? 'icon-new-man'
                      : 'ungendered'
                "></span>
            </div>
            <p class="age">{{ getAgeSection(rankingItem.user?.age) }}</p>
          </div>
          @if (rankingItem.equipment) {
            <p class="manufacturer">
              {{ rankingItem.equipment.manufacturer.name }}
            </p>
          }
          @if (rankingItem.rank % 2 === 0) {
            <div class="background"></div>
          }
        </div>
      }

      @if (emptyRanking && selectedFilters.length === 0) {
        <div class="empty-ranking-placeholder">
          <span class="icon icon-challenge-cup"></span>
          {{ 'watch.ranking_modal.placeholder.empty_ranking' | translate }}
        </div>
      }

      @if (emptyRanking && selectedFilters.length > 0) {
        <div class="empty-ranking-placeholder">
          <span class="icon icon-challenge-cup"></span>
          {{
            'watch.ranking_modal.placeholder.empty_ranking_filters' | translate
          }}
        </div>
      }

      @if (rankingLoading$ | async) {
        <div class="skeletons">
          <div class="empty-skeleton"></div>
          <p-skeleton height="4em" />
          <div class="empty-skeleton"></div>
          <p-skeleton height="4em" />
          <div class="empty-skeleton"></div>
          <p-skeleton height="4em" />
          <div class="empty-skeleton"></div>
          <p-skeleton height="4em" />
          <div class="empty-skeleton"></div>
        </div>
      }
    </div>
  </div>

  <div class="footer"></div>
</div>
